// Post slug rules, mirroring the API's posts-model.ts validation so the UI
// can reject bad slugs before a round trip.
const POST_SLUG_PATTERN = /^[a-z0-9][a-z0-9-]*$/;
const MAX_POST_SLUG_LENGTH = 80;

export function slugifyPostTitle(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, MAX_POST_SLUG_LENGTH);
}

export function postSlugProblem(slug: string): string {
  if (!POST_SLUG_PATTERN.test(slug) || slug.length > MAX_POST_SLUG_LENGTH) {
    return "Use lowercase letters, numbers and hyphens (start with a letter or number).";
  }
  if (slug === "category") return '"category" is reserved.';
  if (/^[0-9]+$/.test(slug)) return "Slugs can't be a number only.";
  return "";
}
